// extracted by mini-css-extract-plugin
module.exports = {"alternativeAudience":"AlternativeAudience_alternativeAudience__fUHXQ","noMargin":"AlternativeAudience_no-margin__YeRuh"};